import React from "react";
import {observer} from "mobx-react";
import {SpinnerBox} from "./boxes/spinner/spinner.box";
import {CyClass} from "../../../common/cy-classes";
import {SpinnerBrandBox} from "./boxes/spinner-brand/spinner-brand.box";
import {SpinnerBackgroundBox} from "./boxes/spinner-background/spinner-background.box";
import {SpinnerLogoBox} from "./boxes/spinner-logo/spinner-logo.box";
import {SpinnerSubtextBox} from "./boxes/spinner-subtext/spinner-subtext.box";
import {useServices} from "../../react-hooks/use-services.hook";
import classNames from 'classnames';

interface SpinnerContentComponentProps {
    isMigrationSpinner: boolean;
    className?: string;
}

export const SpinnerContentComponent: React.FC<SpinnerContentComponentProps> = observer((props) => {
    const services = useServices();

    const renderSubText = () => {
        if (props.isMigrationSpinner) {
            return (
                <SpinnerSubtextBox>{services.translation.translate('LOGGING_IN')}</SpinnerSubtextBox>
            );
        }
        return null;
    }

    return (
        <SpinnerBox isMigrationSpinner={props.isMigrationSpinner} className={classNames(props.className, CyClass('cy-spinner'))}>
            <SpinnerBrandBox className='cy-spinner-brand'>
                <SpinnerBackgroundBox className='cy-spinner-background'/>
                <SpinnerLogoBox className='cy-spinner-logo' isRTL={services.language.isRTLLanguage} />
                {renderSubText()}
            </SpinnerBrandBox>
        </SpinnerBox>
    );
})